import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import DateOfBirthVerificationFailed from "@app/pages/private/dateOfBirthVerification/dateOfBirthVerificationFailed";
import { GradientWrapper } from "@app/components";
import { usePortalRedirects } from "@app/hooks";

import "./welcomeDobVerificationFailed.scss";

const messages = defineMessages({
  scheduleBloodDrawDobFailedTitle: {
    id: "scheduleBloodDrawDobFailed",
    defaultMessage: "We are unable{br}to verify your date of birth",
  },
  scheduleBloodDrawDobFailedDescription: {
    id: "scheduleBloodDrawDobFailedDescription",
    defaultMessage:
      "The date of birth you entered does not match our records. Please contact your ordering clinic or Natera support.",
  },
  scheduleBloodDrawDobFailedActionButton: {
    id: "scheduleBloodDrawDobFailedActionButton",
    defaultMessage: "Close",
  },
});

const WelcomeDobVerificationFailedScreen: FC = () => {
  const intl = useIntl();
  const { toLogin } = usePortalRedirects();

  return (
    <div className="schedule-blood-draw__dob-failed">
      <DateOfBirthVerificationFailed
        title={intl.formatMessage(messages.scheduleBloodDrawDobFailedTitle, {
          br: <br />,
        })}
        description={intl.formatMessage(
          messages.scheduleBloodDrawDobFailedDescription
        )}
        button={{
          action: () => toLogin({ preserveQuery: false }),
          label: intl.formatMessage(
            messages.scheduleBloodDrawDobFailedActionButton
          ),
        }}
      />
    </div>
  );
};

export default WelcomeDobVerificationFailedScreen;
